import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { faSquareXmark, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import * as moment from 'moment';
import { fadeIn, fadeOut } from 'src/app/animations';
import { TipoBeneficio } from 'src/app/shared/enum/tipo-beneficio';
import { DataService } from 'src/app/shared/services/data.service';
import Swal from 'sweetalert2';
import { BeneficioService } from '../../../services/previdencia/beneficio.service';
import { SocialSecurityService } from '../../../services/previdencia/social-security.service';
@Component({
  selector: 'app-solicitacao-beneficio',
  templateUrl: './solicitacao-beneficio.component.html',
  styleUrls: ['./solicitacao-beneficio.component.css'],
  animations: [fadeIn, fadeOut]
})
export class SolicitacaoBeneficioComponent implements OnInit {
  //Icones
  faSquareXmark = faSquareXmark;
  currentDate: string = moment().format("DD/MM/YYYY");
  uniqueArr: any;
  loadingCosts: boolean = false;
  tipoBeneficio: any;
  dependentesSelecionados = new Array();
  errorCosts: boolean = false;
  myBenefitRequests: any;
  tipos: any;
  tipoAposentadoria: string = '';
  benefitBase: any;
  pessoa: any;
  dependentes: any;
  dependentesFiltered: any;
  contaAtiva: any;
  titulares: any;
  plans: any;
  banks: any;
  filesList64: any;
  aposentadoriaPendente: any;
  adiantamentoPendente: any;
  dadosBancarios: any;
  todosSelecionados: boolean = false;
  tipoBeneficioEnum: any = TipoBeneficio;
  tiposDeBanco: any = [{ name: 'Corrente', value: 'corrente' }, { name: 'Poupança', value: 'poupanca' }]
  myBenefitRequestsFilter = { itemsPerPage: 10, page: 0 };
  @ViewChild('stepper') stepper!: MatStepper;
  firstFormGroup = this._formBuilder.group({ firstCtrl: ['', Validators.required] });
  secondFormGroup = this._formBuilder.group({ secondCtrl: ['', Validators.required] });
  isLinear = false;
  //ICONES
  faTriangleExclamation = faTriangleExclamation;
  exceededMaxFileSize: boolean = false;
  loading: boolean = false;
  formFile = new FormGroup({ files: this.createOtherFile(false) })
  formDependentes = new FormGroup({ dependentes: this.createOtherFile(false) })
  form: FormGroup = new FormGroup({
    acceptedTerms: new FormControl(false, [Validators.required]),
    agencia: new FormControl(null, [Validators.required]),
    banco: new FormControl(null, [Validators.required]),
    benefityTypeId: new FormControl(null, [Validators.required]),
    conta: new FormControl(null, [Validators.required]),
    dependentes: new FormControl(null),
    files: this.createOtherFile(false),
    tipoConta: new FormControl(null, [Validators.required]),
    titularId: new FormControl(null),
  });
  file: FormGroup = new FormGroup({
    contentType: new FormControl(null),
    file: new FormControl(null),
    fileName: new FormControl(null),
  });
  constructor(private router: Router, private beneficio: BeneficioService, private socialSecurityService: SocialSecurityService,
    public data: DataService, private _formBuilder: FormBuilder) {
    this.socialSecurityService.getPersonData().subscribe({
      next: (res: any) => {
        this.form.get('planId')?.setValue(res.personData?.adesoes[0].planId);
      }
    });
    this.loadingCosts = !this.loadingCosts;
    this.beneficio.getBase().subscribe((res: any) => {
      this.benefitBase = res;
      this.dependentes = res.dependentes;
      this.titulares = res.titulares;
      this.tipos = res.tipos;
      this.data.data = res.contaAtiva;
      this.pessoa = res.pessoa;
      this.dadosBancarios = res.contaAtiva;
      this.form.patchValue(res.contaAtiva);
      this.form.get('tipoConta')?.setValue(res.contaAtiva.tipo_Conta);
    });
    this.beneficio.getBenefits(this.myBenefitRequestsFilter).subscribe((res2: any) => {
      this.loadingCosts = !this.loadingCosts;
      this.myBenefitRequests = res2.items;
      this.myBenefitRequests.forEach((element: any) => {
        if (element.benefitTypeId == 1 && element?.statusId != 7 || element.benefitTypeId == 2 && element?.statusId != 7) {
          //RETIRA APOSENTADORIA PROGRAMADA E INVALIDEZ DO COMBOBOX
          this.aposentadoriaPendente = (element?.statusId == 1 || element?.statusId == 7) ? 'Andamento' : 'Concluido';
          this.tipos = this.tipos.filter(
            (a: any) => {
              return a.description != 'Aposentadoria Invalidez' && a.description != 'Aposentadoria Programada';
            }
          )
        } else if (element.benefitTypeId == 6 && element?.statusId != 7) {
          this.adiantamentoPendente = (element?.statusId == 1 || element?.statusId == 5) ? 'Andamento' : 'Concluido';
          this.tipos = this.tipos.filter(
            (a: any) => {
              return a.id != 6;
            })
        }
      });
    })
  }
  selecionarTodos() {
    this.dependentesSelecionados = [];
    this.dependentesSelecionados = this.dependentes;
    //Verifica se o botão já foi clicado uma vez, se sim ele transforma todos em false
    if (this.todosSelecionados == true) {
      document.querySelectorAll('input[type="checkbox"]:not([id^="f"])').forEach(
        (e: any) => {
          e['checked'] = false;
        }
      );
    }
    //Percorrer todos os elementos voltados pelo querySelector e transorma todos os estado checked em true
    if (this.todosSelecionados == false) {
      document.querySelectorAll('input[type="checkbox"]:not([id^="f"])').forEach(
        (e: any) => {
          e['checked'] = true;
        }
      );
    }
    this.todosSelecionados = !this.todosSelecionados;
  }
  ngOnInit(): void {
    let lista = JSON.stringify(this.dependentes);
  }
  checked(id: any, posicao: number) {
    if (this.dependentesSelecionados.find((dependente: any) => dependente.cpf_Dependente === id.cpf_Dependente)) {
      this.dependentesSelecionados = this.dependentesSelecionados.filter(
        (x: any) => {
          return x.cpf_Dependente !== id.cpf_Dependente;
        }
      )
    } else {
      this.dependentesSelecionados.push(id);
    }
    this.dependentesSelecionados.sort(
      (a: any, b: any) => {
        if (a.nome > b.nome) return 1;
        if (a.nome < b.nome) return -1;
        return 0;
      }
    );
  };
  removeDuplicates() {
    const uniqueMap = new Map<number, Object>();
    this.dependentes.forEach((item: any) => {
      uniqueMap.set(item.id, item);
    });
    this.dependentesFiltered = Array.from(uniqueMap.values());
  }
  solicitarBeneficio() {
    this.loading = true;
    this.beneficio.postSalvarBeneficio({
      acceptedTerms: this.form.get('acceptedTerms')?.value,
      agencia: this.form.get('agencia')?.value,
      banco: this.form.get('banco')?.value,
      benefitTypeId: this.form.get('benefityTypeId')?.value,
      conta: this.form.get('conta')?.value,
      dependentes: this.dependentesSelecionados,
      files: this.form.get('files.files')?.value,
      tipoConta: (this.form.get('')?.value == 'corrente') ? 2 : 1,
    }).subscribe({
      next: (res: any) => {
        this.loading = false;
        Swal.fire({
          title: 'Solicitação realizada com sucesso!!',
          icon: 'success',
          showConfirmButton: true,
          confirmButtonColor: '#1A428A',
          confirmButtonText: 'Voltar',
          showClass: {
            popup: 'animate__animated animate__fadeInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp'
          }
        }).then(() => {
          this.router.navigate(["minhas-solicitacoes-beneficio"]);
        });
      }
    });
  }
  createOtherFile(enabled: boolean) {
    return new FormGroup({
      name: new FormControl({ value: 'otherFiles', disabled: !enabled }),
      files: new FormControl({ value: null, disabled: !enabled }),
    })
  }
  adicionarDocumento(event: any) {
    this.form.get(`files.files`)?.setValue(event);
    this.form.get(`files`)?.updateValueAndValidity();
    // this.form.get('files.files')?.setValue(event);
    // this.form.get('files')?.updateValueAndValidity();
  }
  onSelectOpened() {
    this.stepper.reset();
  }
  onSelectClose() {
    this.tipoAposentadoria = this.tipos.filter((x: any) => {
      return x.id === this.form.get('benefityTypeId')?.value
    })[0]?.description;
  }
  deleteDependant(dependant: any, index: any) {
    let dependants = this.form.get('dependants')?.value;
    dependants.splice(index, 1);
    this.form.get('dependants')?.patchValue(dependants);
    this.form.get('dependants')?.updateValueAndValidity();
  }
  removeFile(fileType: string, index: number) {
    let actualSize = 0
    const maxSize = 1048576 * 25;
    let files = this.form.get(`files.files`)?.value;
    files.splice(index, 1);
    this.form.get(`files.files`)?.patchValue(files)
    files.forEach((f: any) => actualSize += (f.size * 1024)
    );
    if (actualSize > maxSize) { this.exceededMaxFileSize = true; return false; }
    this.exceededMaxFileSize = false;
    return true;
  }
}